

























// Composition
import { computed, defineComponent, useRouter } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'

// Store
import { useSearchStore } from '@/store/search'

// Composable
import useSearch from '@/composables/search/useSearch'
import useSearchUrl from '@/composables/search/useSearchUrl'

// Component
import FacetBlock from '@/components/feature/search/facets/FacetBlock.vue'
import IconFa6SolidXmark from '~icons/fa6-solid/xmark'

// Common
import { showAllFacetsArray } from '@/common/static/facets'

// Types
import { FacetsObjectInterface, StaticFacetsInterface } from '@/types/search/searchTypes'

import { useMobile } from '~/composables/ui/useMobile'

export default defineComponent({
  components: {
    FacetBlock,
    IconFa6SolidXmark,
  },

  setup() {
    const searchStore = useSearchStore()
    const { getResults: results, facets } = storeToRefs(searchStore)
    const { setDefaultSearchSettings } = useSearch()
    const { getSearchUrl } = useSearchUrl()
    const router = useRouter()
    const { isMobile } = useMobile()

    // Order facets based on showfactsArray
    const orderedFacets = () => {
      const orderedFacets = {} as FacetsObjectInterface

      // find prop in results.facets for every root facet and place it in a new object
      showAllFacetsArray.forEach((facet) => getFacetFromResults(facet, orderedFacets))

      return orderedFacets
    }

    const mobileScrollbar = computed(() => (isMobile ? 'custom-scroll' : ''))

    const getFacetFromResults = (facet: string | object, orderedFacets: FacetsObjectInterface) => {
      if (typeof facet === 'string') {
        if (results?.value?.facets !== undefined) {
          if (results.value.facets[facet] !== undefined) {
            orderedFacets[facet] = results.value.facets[facet]
          }
        }
      } else {
        orderedFacets.other = []
        Object.values(facet).forEach((facetParent: Array<StaticFacetsInterface>) => {
          facetParent.forEach((facet) => {
            if (results?.value?.facets !== undefined) {
              if (results.value.facets[facet.facetName] !== undefined) {
                orderedFacets.other.push({
                  [facet.facetName]: [
                    ...results.value.facets[facet.facetName],
                    { facetPrettyName: facet.facetPrettyName },
                  ],
                })
              }
            }
          })
        })
      }

      return orderedFacets
    }

    const clearAll = () => {
      // Back to default
      setDefaultSearchSettings(true)

      // Perform a search
      router.push(getSearchUrl())
    }

    return {
      facets,
      results,
      searchStore,
      clearAll,
      orderedFacets,
      mobileScrollbar,
    }
  }, // end setup
})
